import styled from "vue-styled-components";

export const Content = styled.div`
    margin-bottom: 2rem;

    label {
        margin-bottom: 0.3rem;
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        font: 600 1.5rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        letter-spacing: .005em;
        display: inline-block;
    }

    .container-variation {
        display:flex;
    }

    .scroll-container {
        max-height: 200px;
        overflow-y: scroll;
        scrollbar-color: ${props => props.theme?.products?.product_page?.variations?.scroll_color ?? '#4a505e'} #fff;
        border: 1px solid #eee;
        max-width: 400px;
        float:left;
    }

    ul {
        float:left;
        display: flex;
        flex-wrap: wrap;
        gap: 0.3rem;
        margin: 0.7rem;
        justify-content: center;

        li {
            font-size: 1.3rem;
            padding: 0.4rem 1rem;
            cursor: pointer;
            transition: 0.2s;
            max-width: 170px;
            margin: 5px 0;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);

            color: ${props => props.theme?.products?.product_page?.variations?.color ?? '#000000'};
            border: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color ?? '#dee2e6'};
            border-radius: ${props => props.theme?.products?.product_page?.variations?.border_radius ?? '0'};
            background: ${props => props.theme?.products?.product_page?.variations?.background_color ?? 'transparent'};

            &:hover,
            &.active {
                color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? '#000000'};
                border: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
                background: ${props => props.theme?.products?.product_page?.variations?.background_color_active ?? 'transparent'};
            }

            &.unavailable {
                pointer-events: none;
                opacity: 0.85;
                border: 1px solid tomato;
                text-decoration: line-through tomato;
            }

            @media (max-width: 475px) {
               max-width: 160px;
            }
        }
    }
`;
